import classNames from "classnames";
import styles from "./content-page-header.less";
import { useMemo } from "react";

type ContentPageHeaderProps = {
    title: string;
    preTitleElement?: React.ReactNode;
    preHeaderButtonElement?: React.ReactNode;
    headerButton?: React.ReactNode;
    className?: string;
};

export const ContentPageHeader = (props: ContentPageHeaderProps) => {
    const {
        title,
        preTitleElement,
        preHeaderButtonElement,
        headerButton,
        className
    } = props;

    const headerButtonClassName = useMemo(() => {
        if (headerButton && preHeaderButtonElement) {
            return styles.headerButtonWithPreElement;
        } else {
            return styles.headerButton;
        }
    }, [headerButton, preHeaderButtonElement]);

    return (
        <div className={classNames(styles.contentPageHeader, className ? className : "")}>
            <div className={styles.contentHeader}>
                {preTitleElement && (
                    <div className={styles.preTitleElement}>
                        {preTitleElement}
                    </div>
                )}
                <h1>{title}</h1>
                {preHeaderButtonElement && (
                    <div className={styles.preHeaderButtonElement}>
                        {preHeaderButtonElement}
                    </div>
                )}
                {headerButton && (
                    <div className={headerButtonClassName}>
                        {headerButton}
                    </div>
                )}
            </div>
            <hr />
        </div>
    );
};